import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { FaCalendarAlt } from "react-icons/fa";
import {
  Calendar as MultiDatePickerCalendar,
  DateObject,
} from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import styled from "styled-components";
import useOutsideClick from "hooks/useOutsideClick";
import { isBlank, getErrorMessage } from "helpers/strings";

export const CustomDateInput = styled.input`
    border-radius: ${(props) => (props.radius ? props.radius : '14')}px;
    border: 1px solid ${(props) => (props.error ? '#FF1744' : '#C8C8C8')};
    text-align: center;
    background: white !important;
    padding-top: 0.5rem;
    width: 100%;
    cursor: pointer;
`;

const Calendar = styled(MultiDatePickerCalendar)`
  position: absolute;
  top: ${(props) => (props.top ? props.top : "70")}%;
  left: ${(props) => (props.left ? props.left : "50")}%;
  display: ${(props) => (props.show ? "block" : "none")};
`;

const dateObject = new DateObject({ calendar: persian, locale: persian_fa });

const PersianPickerInput = ({
  currentDate,
  topOffset,
  leftOffset,
  onPick,
  label,
  error,
  field,
  touched
}) => {
  const compRef = useRef();
  const [showPicker, setShowPicker] = useState(false);

  const getDateLabel = () => {
    const current = currentDate
      ? new DateObject(new Date(currentDate))
        .convert(persian, persian_fa)
        .format()
      : dateObject.format();

    return `${label}    |    ${current}`;
  };

  const onDateChange = useCallback(
    (newDate) => {
      onPick?.(
        newDate
          .convert(gregorian, gregorian_en)
          .toUTC()
          .format("YYYY-MM-DD")
      );
      setShowPicker(false);
    },
    [onPick]
  );

  useOutsideClick(compRef?.current, () => {
    setShowPicker(false);
  });

  const renderCalendar = useCallback(
    () => (
      <Calendar
        show={showPicker}
        calendar={persian}
        locale={persian_fa}
        onChange={onDateChange}
        top={topOffset}
        left={leftOffset}
        value={new Date(currentDate)}
      />
    ),
    [showPicker, leftOffset, onDateChange, currentDate]
  );

  return (
    <div ref={compRef} onClick={() => setShowPicker(true)}>
      <CustomDateInput
        className={touched && error ? "invalid" : ""}
        error={!isBlank(error)}
        {...field}
        radius="14"
        readOnly
        value={getDateLabel()}
      />
      {showPicker && renderCalendar()}
    </div>
  );
};

export default PersianPickerInput;
